export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8177.d04f20d9.jpg";